import Noty from 'noty';
import {
	notyErrorLayout,
	notySuccessLayout,
	notyCLoseButton,
	notyNotificationLayout,
	notyLoadingLayout
} from './constants';

/**
 * Class to display error message using "Noty.js" notifier.
 */
export default class Notify {
	/**
	 * Method to display error messages.
	 *
	 * @param errorMessage
	 * @param timeout
	 */
	error(errorMessage = 'There was an error', timeout = 5000) {
		const n = new Noty({
			text: notyErrorLayout(errorMessage),
			buttons: [
				Noty.button(notyCLoseButton, 'noty_btn noty_btn-close', function() {
					n.close();
				}),
			],
			closeWith: 'button',
			timeout: timeout,
		}).show();
	}

	/**
	 * Method to display success messages.
	 *
	 * @param successMessage
	 * @param timeout
	 */
	success(successMessage, timeout = 5000) {
		const n = new Noty({
			text: notySuccessLayout(successMessage),
			buttons: [
				Noty.button(notyCLoseButton, 'noty_btn noty_btn-close', function() {
					n.close();
				}),
			],
			closeWith: 'button',
			timeout: timeout,
		}).show();
	}


	/**
	 * Notification
	 *
	 * @param message
	 * @param timeout
	 */
	notification(message, timeout = 5000) {
		const n = new Noty({
			text: notyNotificationLayout(message),
			buttons: [
				Noty.button(notyCLoseButton, 'noty_btn noty_btn-close', function() {
					n.close();
				}),
			],
			type: 'information',
            killer: true,
			layout: 'bottomCenter',
			closeWith: 'button',
			timeout: timeout,
		}).show();
	}

	loading(message, timeout = 5000) {
		const n = new Noty({
			text: notyLoadingLayout(message),
			buttons: [
				Noty.button(notyCLoseButton, 'noty_btn noty_btn-close', function() {
					n.close();
				}),
			],
			closeWith: 'button',
			timeout: timeout,
		}).show();
	}
}
